// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimer {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
}

.medication-alerts-content.upload-blocking {
  pointer-events: none;
  opacity: 0.7;
}

.alert-type-option {
  padding: 12px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  margin-bottom: 12px;
  background-color: #F9FAFB;
  transition: all 0.2s ease;
}
.alert-type-option:hover {
  background-color: #F3F4F6;
  border-color: #D1D5DB;
}
.alert-type-option:last-child {
  margin-bottom: 0;
}

.alert-type-label {
  font-weight: 600;
  font-size: 14px;
  color: #1F2937;
  cursor: pointer;
}

.alert-type-description {
  margin-left: 28px;
  font-size: 13px;
  line-height: 1.5;
  color: #6B7280;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
}

:host ::ng-deep .gc-form-section .sidebar-form label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #1E38A9;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea {
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 7rem;
  box-sizing: border-box;
  resize: vertical !important;
  overflow: auto;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center {
  display: flex !important;
  align-items: center !important;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center p-radioButton {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center p-radioButton ::ng-deep .p-radiobutton {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center p-radioButton ::ng-deep .p-radiobutton .p-radiobutton-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center label {
  display: inline-flex !important;
  align-items: center !important;
  margin-bottom: 0 !important;
  line-height: 1.5;
  cursor: pointer;
  vertical-align: middle;
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  max-width: 400px;
}

.text-center {
  text-align: center;
}

.assing-agncy {
  height: 54px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  font-size: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  color: #2d388b;
  text-align: center;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c7c7c7;
  padding: 4px;
}
.assing-agncy .assing-agncy-filed {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.p-multiselect-wrapper {
  position: relative;
}

:host ::ng-deep .p-multiselect {
  border-radius: 6px;
  border: 1px solid #ced4da;
  padding: 14px 8px;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
}
:host ::ng-deep .p-multiselect .p-multiselect-label-container {
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 24px;
}
:host ::ng-deep .p-multiselect .p-multiselect-label {
  padding: 0;
  font-size: 16px;
  color: #6b7280;
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 4px;
}
:host ::ng-deep .p-multiselect .p-multiselect-token {
  margin: 0 2px;
}
:host ::ng-deep .p-multiselect .p-multiselect-trigger {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 12px;
  flex-shrink: 0;
}
:host ::ng-deep .p-autocomplete {
  width: 100%;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input {
  width: 100%;
  border: none;
  padding: 0;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input:focus {
  box-shadow: none;
}
:host ::ng-deep .assing-agncy-filed .p-autocomplete {
  flex: 1;
}
:host ::ng-deep .p-multiselect-panel {
  border-radius: 6px;
  margin-top: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
:host ::ng-deep .p-multiselect-panel .p-multiselect-items {
  padding: 8px;
}

:host ::ng-deep .table-header > .align-items-center.flex:first-child {
  flex: 0 1 auto;
  min-width: 0;
}
:host ::ng-deep .table-header > .align-items-center.flex:first-child h2 {
  white-space: nowrap;
  flex-shrink: 0;
  margin: 0;
}
:host ::ng-deep .table-header .user-label {
  min-width: auto;
  width: auto;
  padding: 0 8px;
  flex-shrink: 0;
}
:host ::ng-deep .table-header .user-label img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
:host ::ng-deep .table-header .user-label img[src*=medication-alert-icon] {
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(212deg) brightness(97%) contrast(92%);
  width: 24px;
  height: 24px;
}
:host ::ng-deep .table-header .user-label span {
  white-space: nowrap;
}

:host ::ng-deep .button-sm.add-icon,
:host ::ng-deep .button-sm.upload-icon {
  white-space: nowrap;
  min-width: auto;
}
:host ::ng-deep .button-sm.add-icon .p-button-label,
:host ::ng-deep .button-sm.upload-icon .p-button-label {
  white-space: nowrap;
}

:host ::ng-deep .table-header > .align-items-center.flex:last-child .p-button,
:host ::ng-deep .table-header > .align-items-center.flex:last-child p-button .p-button {
  font-size: 0.875rem !important;
  padding: 0.5rem 0.8rem !important;
  min-height: 2.25rem !important;
}
:host ::ng-deep .table-header > .align-items-center.flex:last-child .p-button .p-button-icon,
:host ::ng-deep .table-header > .align-items-center.flex:last-child p-button .p-button .p-button-icon {
  font-size: 0.85rem !important;
}

:host ::ng-deep .bulkUpload-btn.download-library-btn {
  border-color: #6ACE6A !important;
  background: #6ACE6A !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button {
  background: transparent !important;
  border: none !important;
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button .p-button-label {
  color: #ffffff !important;
  white-space: nowrap;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button .p-button-icon {
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button:hover,
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button:focus {
  background: transparent !important;
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-dropdown .p-dropdown-trigger {
  border-left-color: rgba(255, 255, 255, 0.5) !important;
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-dropdown .p-dropdown-trigger .pi {
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-dropdown:hover .p-dropdown-trigger,
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-dropdown.p-focus .p-dropdown-trigger {
  border-left-color: rgba(255, 255, 255, 0.7) !important;
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn:hover {
  background: #7AEC7A !important;
  border-color: #7AEC7A !important;
}

:host ::ng-deep .p-datatable tbody tr td.text-center {
  vertical-align: middle !important;
  padding: 1rem;
  text-align: center;
}
:host ::ng-deep .p-datatable tbody tr td.text-center > .flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  height: 100%;
  min-height: 2.5rem;
}
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text {
  width: 2.5rem !important;
  height: 2.5rem !important;
  min-width: 2.5rem !important;
  min-height: 2.5rem !important;
  max-width: 2.5rem !important;
  max-height: 2.5rem !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0;
  position: relative;
}
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text .p-button-icon-right {
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:hover .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:hover .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:hover .p-button-icon-right, :host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:focus .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:focus .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:focus .p-button-icon-right, :host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:active .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:active .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:active .p-button-icon-right, :host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text.p-focus .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text.p-focus .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text.p-focus .p-button-icon-right {
  margin: 0 !important;
  padding: 0 !important;
  transform: translate(-50%, -50%) !important;
  top: 50% !important;
  left: 50% !important;
}
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text .p-button-label {
  display: none;
}

:host ::ng-deep .bulkUpload-btn .medication-batch-upload-panel,
:host ::ng-deep .bulkUpload-btn .p-dropdown-panel {
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) !important;
}

:host ::ng-deep .upload-summary-dialog .p-dialog-header {
  background-color: #F6F8FF;
  color: #495057;
  border-radius: 6px 6px 0 0;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-title {
  color: #1E38A9;
  font-weight: 600;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-icon,
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-close,
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-close-icon,
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-button-icon {
  color: #6c757d;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-icon:hover,
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-close:hover {
  color: #495057;
  background-color: #e9ecef;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-content {
  padding-top: 20px;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-footer {
  border-top: 1px solid #D1D5DB;
  padding-top: 20px;
}

.upload-summary-content .upload-summary-success {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;
}
.upload-summary-content .upload-summary-success .upload-summary-success-icon {
  color: #22c55e;
  font-size: 20px;
  flex-shrink: 0;
}
.upload-summary-content .upload-summary-success .upload-summary-info-icon {
  color: #1e38a9;
  font-size: 20px;
  flex-shrink: 0;
}
.upload-summary-content .upload-summary-success .upload-summary-error-icon {
  color: #ef4444;
  font-size: 20px;
  flex-shrink: 0;
}
.upload-summary-content .upload-summary-success .upload-summary-success-text {
  color: #1e38a9;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
}
.upload-summary-content .upload-summary-success .upload-summary-error-text {
  color: #ef4444;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
}
.upload-summary-content .upload-summary-body {
  padding-left: 4px;
}
.upload-summary-content .upload-summary-body .upload-summary-line {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 10px 0;
  font-size: 15px;
  line-height: 1.5;
  color: #374151;
}
.upload-summary-content .upload-summary-body .upload-summary-line em {
  font-size: 18px;
  flex-shrink: 0;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-line-updated .upload-summary-icon-updated {
  color: #1e38a9;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-line-added .upload-summary-icon-added {
  color: #22c55e;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-line-removed .upload-summary-icon-removed {
  color: #ef4444;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-total {
  font-weight: 600;
  margin-top: 14px;
  margin-bottom: 0;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-total .upload-summary-icon-total {
  color: #9ca3af;
}
.upload-summary-content .upload-summary-body.upload-summary-error-body .upload-summary-row-error-line {
  margin-bottom: 6px;
}
.upload-summary-content .upload-summary-body.upload-summary-error-body .upload-summary-row-error-line:last-child {
  margin-bottom: 0;
}
.upload-summary-content .upload-summary-body.upload-summary-error-body .upload-summary-row-error-line span {
  font-size: 13px;
  color: #374151;
}

.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.dropzone .textLink {
  color: #1F2937 !important;
}
.dropzone .textLink u {
  text-decoration: underline;
  margin-left: 4px;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}

.status-active {
  color: #6ACE6A;
  font-weight: 600;
}

.status-inactive {
  color: #ff3c3c;
  font-weight: 600;
}

.checkbox-cursor-pointer ::ng-deep .p-checkbox-label {
  cursor: pointer;
}

:host ::ng-deep .table-header .user-label img[alt=app-link-icon] {
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(212deg) brightness(97%) contrast(92%);
}

.popup-wrapper {
  position: relative;
}

.sidebar-interaction-blocker {
  position: absolute;
  inset: 0;
  z-index: 10;
  background: transparent;
  cursor: not-allowed;
}

.disabled-action {
  opacity: 0.5;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
